import React from 'react';
import {
    Box,
    Text,
    Flex,
    Heading,
    Stack,
    Button,
    IconButton,
    useColorModeValue,
    Tooltip,
} from "@chakra-ui/react";
import { FaFileAlt, FaDownload } from "react-icons/fa";
import {FiArrowRight} from "react-icons/fi";
import {updateProjectStatus} from "./DesignTab/utils";
import {useParams} from "react-router-dom";

const ReportsTab = ({setActiveTab}) => {
    const cardBg = useColorModeValue("white", "gray.700");
    const cardShadow = useColorModeValue("md", "xl");
    const cardBorderColor = useColorModeValue("gray.200", "gray.600");
    const {projectId} = useParams();

    const reports = [
        { id: 1, name: "Monthly Overview Report" },
        { id: 2, name: "Technology Efficiency Analysis" },
        { id: 3, name: "Quarterly Consumption Summary" },
        // Add more reports as needed
    ];

    const handleNext = () => {
        updateProjectStatus(projectId, "complete").then();
        setActiveTab(4);
    }
    return (
        <Box p={10}>
            <Stack spacing={6}>
                {reports.map(report => (
                    <Box
                        key={report.id}
                        bg={cardBg}
                        boxShadow={cardShadow}
                        p={5}
                        borderRadius="md"
                        borderWidth="1px"
                        borderColor={cardBorderColor}
                    >
                        <Flex justify="space-between" align="center">
                            <Text fontSize="lg" fontWeight="medium">{report.name}</Text>
                            <Tooltip label="Download Report" aria-label="Download Report Tooltip">
                                <IconButton
                                    icon={<FaDownload />}
                                    colorScheme="blue"
                                    variant="outline"
                                    onClick={() => {
                                        // Handle download logic here
                                        console.log(`Downloading ${report.name}`);
                                    }}
                                />
                            </Tooltip>
                        </Flex>
                    </Box>
                ))}
            </Stack>
            <Button
                position="absolute" right={4}
                bottom={4}
                rightIcon={<FiArrowRight/>}
                colorScheme="blue"
                onClick={handleNext}
            >
                View Documentation
            </Button>
        </Box>
    );
}

export default ReportsTab;
